import { cloneProviderClient, unwrap } from './cloneProviderClient';

export async function getAccountsStats() {
  const response = await cloneProviderClient.get('/stats/accounts');
  return unwrap(response);
}

export async function getProvidersStats() {
  const response = await cloneProviderClient.get('/stats/providers');
  return unwrap(response);
}

export async function getPurchasesStats() {
  const response = await cloneProviderClient.get('/stats/purchases');
  return unwrap(response);
}

export async function getMetricsSeries() {
  const response = await cloneProviderClient.get('/stats/metrics');
  return unwrap(response);
}

const statsService = { getAccountsStats, getProvidersStats, getPurchasesStats, getMetricsSeries };
export default statsService;
